import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import { service } from '@ember/service';
import type DepartmentModel from 'scaleflow/models/department';
import type TeamModel from 'scaleflow/models/team';

export default class CompanyDepartmentInitiativesController extends Controller {
  @service declare betaToggle: BetaToggleService;

  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'product_managers',
    'teams',
    'show_grouping',
    'start_date',
    'end_date',
    'columns',
  ];

  declare model: DepartmentModel;

  @tracked grouping = null;
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked productManagers = [];
  @tracked teams = [];
  @tracked columns: string[] = [];
  @tracked roadmaps = [];
  @tracked goals = [];

  showColumn(column: { show?: boolean; label: string }) {
    if (this.columns.length === 0) {
      if (column.show !== undefined) return column.show;
      return true;
    } else {
      return this.columns.includes(column.label);
    }
  }

  get teamIds() {
    return (this.model.teams.content ?? []).map(
      (team: TeamModel) => (team as any).id!,
    );
  }

  get columnOptions() {
    const columns = [...this.betaToggle.columnOptions];
    columns.forEach((item: { show?: boolean; label: string }) => {
      item.show = this.showColumn(item);
    });
    return columns.slice();
  }
}
